import classNames from 'classnames';

import type { RipsPackPayload } from '../../stores/rewards/types';
import ImageWithFallback from '../ImageWithFallback/ImageWithFallback';

import classes from './RipsPackReward.module.scss';

export const RIPS_PACK_QUANTITY_TEST_ID = 'rips-pack-quantity';

type RipsPackRewardProps = {
  bundlePayload: RipsPackPayload;
  imageClassName?: string;
  imageDataTestId?: string;
};

export function RipsPackReward({ bundlePayload, imageClassName, imageDataTestId }: RipsPackRewardProps) {
  const { imageUrl, name, quantity } = bundlePayload;

  if (!imageUrl) {
    return null;
  }

  return (
    <div className={classes.ripsPack}>
      <ImageWithFallback
        alt={name || 'Rips pack'}
        className={classNames(classes.ripsPackImage, imageClassName)}
        dataTestId={imageDataTestId}
        src={imageUrl}
      />
      {(quantity ?? 1) > 1 && (
        <span className={classes.ripsPackQuantity} data-testid={RIPS_PACK_QUANTITY_TEST_ID}>
          ×{quantity}
        </span>
      )}
    </div>
  );
}
